module.exports = __webpack_public_path__ + "static/安永复旦中国最具潜力企业2020榜单-c08e98b58b9883e45f173ae489891485.jpg";